document.querySelectorAll(".clube-faq__item").forEach((item) => {
  item.addEventListener("toggle", () => {
    if (!item.open) return;
    document.querySelectorAll(".clube-faq__item").forEach((other) => {
      if (other !== item) other.open = false;
    });
  });
});

function clubeCarouselItems(track) {
  return Array.from(track.children).filter((el) => el.nodeType === 1);
}

function clubeSnapTarget(track, velocity = 0) {
  const items = clubeCarouselItems(track);
  if (!items.length) return track.scrollLeft;

  const maxLeft = Math.max(0, track.scrollWidth - track.clientWidth);
  const center = track.scrollLeft + track.clientWidth / 2;

  let nearest = items[0];
  let nearestIndex = 0;
  let nearestDist = Infinity;

  items.forEach((item, index) => {
    const itemCenter = item.offsetLeft + item.offsetWidth / 2;
    const dist = Math.abs(itemCenter - center);
    if (dist < nearestDist) {
      nearestDist = dist;
      nearest = item;
      nearestIndex = index;
    }
  });

  if (Math.abs(velocity) > 0.45) {
    const direction = velocity > 0 ? -1 : 1;
    const targetIndex = Math.max(
      0,
      Math.min(items.length - 1, nearestIndex + direction)
    );
    nearest = items[targetIndex];
  }

  return Math.min(
    Math.max(
      0,
      nearest.offsetLeft - (track.clientWidth - nearest.offsetWidth) / 2
    ),
    maxLeft
  );
}

function clubeAnimateScroll(track, targetLeft, duration = 280) {
  const startLeft = track.scrollLeft;
  const distance = targetLeft - startLeft;

  if (Math.abs(distance) < 1) return Promise.resolve();

  const startTime = performance.now();

  return new Promise((resolve) => {
    const step = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);

      track.scrollLeft = startLeft + distance * eased;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        resolve();
      }
    };

    requestAnimationFrame(step);
  });
}

function initClubeDragCarousel(track) {
  // Mobile: scroll nativo (inércia do SO + snap CSS). JS customizado causa travada.
  if (window.matchMedia("(max-width: 768px)").matches) return;

  let isDown = false;
  let startX = 0;
  let scrollStart = 0;
  let moved = false;
  let lastX = 0;
  let lastTime = 0;
  let velocity = 0;
  let rafId = 0;
  let snapRafId = 0;
  let velocitySamples = [];

  const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

  const stopAll = () => {
    if (rafId) cancelAnimationFrame(rafId);
    if (snapRafId) cancelAnimationFrame(snapRafId);
    rafId = 0;
    snapRafId = 0;
  };

  const finishWithSnap = (finalVelocity = 0) => {
    const target = clubeSnapTarget(track, finalVelocity);
    if (Math.abs(target - track.scrollLeft) < 2) return;

    clubeAnimateScroll(track, target, 260);
  };

  const runMomentum = () => {
    const friction = 0.955;
    const minVel = 0.25;

    if (Math.abs(velocity) < minVel) {
      rafId = 0;
      finishWithSnap(velocity);
      return;
    }

    const next = track.scrollLeft + velocity;
    if (next <= 0 || next >= maxScroll()) {
      track.scrollLeft = Math.max(0, Math.min(next, maxScroll()));
      rafId = 0;
      finishWithSnap(velocity);
      return;
    }

    track.scrollLeft = next;
    velocity *= friction;
    rafId = requestAnimationFrame(runMomentum);
  };

  track.addEventListener("pointerdown", (event) => {
    if (event.pointerType !== "mouse" || event.button !== 0) return;
    if (event.target.closest("a, button, input, textarea, select, label")) return;

    stopAll();
    isDown = true;
    moved = false;
    velocity = 0;
    velocitySamples = [];
    startX = event.clientX;
    lastX = event.clientX;
    lastTime = performance.now();
    scrollStart = track.scrollLeft;
    track.setPointerCapture(event.pointerId);
  });

  track.addEventListener("pointermove", (event) => {
    if (!isDown) return;

    const now = performance.now();
    const dx = event.clientX - startX;
    const frameDx = event.clientX - lastX;
    const dt = Math.max(now - lastTime, 1);

    if (Math.abs(dx) > 6) {
      moved = true;
      track.classList.add("is-dragging");
    }

    if (!moved) return;

    track.scrollLeft = Math.max(0, Math.min(scrollStart - dx, maxScroll()));

    velocitySamples.push(-frameDx / dt);
    if (velocitySamples.length > 5) velocitySamples.shift();
    velocity =
      (velocitySamples.reduce((sum, sample) => sum + sample, 0) /
        velocitySamples.length) *
      14;

    lastX = event.clientX;
    lastTime = now;
  });

  const endDrag = () => {
    if (!isDown) return;
    isDown = false;
    track.classList.remove("is-dragging");

    if (Math.abs(velocity) > 0.5) {
      runMomentum();
    } else if (moved) {
      finishWithSnap(0);
    }
  };

  track.addEventListener("pointerup", endDrag);
  track.addEventListener("pointercancel", endDrag);
  track.addEventListener("lostpointercapture", endDrag);

  track.addEventListener(
    "click",
    (event) => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    },
    true
  );
}

document.querySelectorAll("[data-carousel]").forEach(initClubeDragCarousel);
